import {z} from 'zod'
import {validateState} from '../ValidateState.ts'
import {PlayerColor} from '../PlayerState.ts'

// CornerVariables: https://prntscr.com/w5qvpk
export enum TileCornerDirection {
    North = 0,
    South = 1,
}

export enum TileCornerBuildingType {
    Settlement = 1,
    City = 2,
    DestroyedCity = 3,
    KnightActiveLevel1 = 4,
    KnightActiveLevel2 = 5,
    KnightActiveLevel3 = 6,
    KnightInactiveLevel1 = 7,
    KnightInactiveLevel2 = 8,
    KnightInactiveLevel3 = 9,
}

export enum TileCornerBonusType {
    IslandSettlingChits = 0,
    CityWall = 1,
    MetropolisScience = 2,
    MetropolisTrade = 3,
    MetropolisPolitics = 4,
}

export const tileCornerStateSchema = z
    .object({
        x: z.number().int().readonly(),
        y: z.number().int().readonly(),
        z: z.enum(TileCornerDirection).readonly(),
        owner: z.enum(PlayerColor).exclude(['None']).optional(),
        buildingType: z.enum(TileCornerBuildingType).optional(),
        bonuses: z.array(z.enum(TileCornerBonusType)).optional(),
        restrictedStartingPlacement: z.literal(true).optional(),
    })
    .strict()

export type TileCornerState = z.infer<typeof tileCornerStateSchema>

export function validateTileCornerState(data: unknown) {
    return validateState(tileCornerStateSchema, data)
}

export const tileCornerStatePartialSchema = tileCornerStateSchema.partial().refine((obj) => Object.keys(obj).length > 0, {
    message: 'At least one property must be provided',
})

export type TileCornerStatePartial = z.infer<typeof tileCornerStatePartialSchema>

export function validateTileCornerStatePartial(data: unknown) {
    return validateState(tileCornerStatePartialSchema, data)
}
